import { isElectron } from './platform';
import nvStorage from './storage';
const audioPath = process.env.NODE_ENV === 'production' && isElectron()
    ? 'static://assets/audio'
    : './assets/audio';
export const inboundRingtones = [
    { name: 'Default', fileName: 'inbound-ringing.mp3' },
    { name: "Classic 90's", fileName: 'classic-90s-ring.mp3' },
    { name: 'Digital Phone', fileName: 'digital-phone-ring.mp3' },
    { name: 'Marimba 1', fileName: 'marimba-ringtone-6.mp3' },
    { name: 'Marimba 2', fileName: 'ringing.mp3' },
    { name: 'Marimba 3', fileName: 'ringtone.mp3' },
    { name: 'Nortel', fileName: 'nortel-phone-ring.mp3' },
    { name: 'Bubbly Bubbles', fileName: 'ringtone-bubbly-bubbles.mp3' },
];
let currentInboundRingtone = nvStorage.get('selectedInboundRingtone') || inboundRingtones[0].fileName;
export const outboundRinging = new Audio(`${audioPath}/ringing.wav`);
const inboundRinging = new Audio(`${audioPath}/inbound/${currentInboundRingtone}`);
const testInboundRinging = new Audio(`${audioPath}/inbound/${currentInboundRingtone}`);
inboundRinging.loop = true;
testInboundRinging.loop = true;
export const setInboundRingtone = (fileName, test = false) => {
    const ringing = test ? testInboundRinging : inboundRinging;
    const isPlaying = !ringing.paused;
    // if (isPlaying) {
    //   ringing.pause();
    // }
    // ringing = new Audio(`${audioPath}/${fileName}`);
    // if (isPlaying) {
    //   ringing.play();
    // }
    if (!test) {
        nvStorage.set('selectedInboundRingtone', fileName);
        currentInboundRingtone = fileName;
    }
    ringing.src = `${audioPath}/inbound/${fileName}`;
    if (isPlaying) {
        ringing.play();
    }
};
export const getInboundRinging = (test = false) => test ? testInboundRinging : inboundRinging;
export const getInboundRingtoneFileName = () => currentInboundRingtone;
const testAudio = new Audio(`${audioPath}/ringing.wav`);
testAudio.volume = 1;
export { testAudio };
